import Raven from 'raven-js';
import analytics from 'client/analytics';
import { ANALYTICS_EVENT_SIGNED_OUT } from 'client/analytics/eventList';
import makeInitialState from 'client/makeInitialState';
import { SR_API_ACTION_LOGOUT } from 'api/actionTypes';
import sendDataToMobileApp, {
  SR_MOBILE_APP_ACTION_TYPE_LOGOUT,
} from 'client/helpers/sendDataToMobileApp';

export default async function logout({ state, apiClient }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_LOGOUT,
    state: state,
    payload: {
      deviceRegistrationId: state.get(['mobileApp', 'deviceRegistrationId']),
    },
    async onSuccess() {
      analytics.track(ANALYTICS_EVENT_SIGNED_OUT);

      const initialState = makeInitialState();
      for (const key of Object.keys(initialState)) {
        state.set(key, initialState[key]);
      }

      Raven.setUserContext();
      analytics.logout();

      sendDataToMobileApp({
        actionType: SR_MOBILE_APP_ACTION_TYPE_LOGOUT,
      });
    },
  });
}
